import React from 'react';

export default function Help() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="max-w-3xl w-full bg-white dark:bg-slate-900/60 border border-slate-200 dark:border-slate-800 rounded-xl p-8 text-center">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-white mb-2">Help Center</h1>
        <p className="text-sm text-slate-600 dark:text-slate-400">This is a minimal placeholder Help Center page. Replace with full content as needed.</p>
      </div>
    </div>
  );
}

